/* tote-survey-kopstorm (Kopstorm CommV) */
(function () {
  'use strict';

  function init() {
  var root = document.querySelector('[data-tote-survey]');
  if (!root || root.dataset.tsReady) return;
  root.dataset.tsReady = '1';

  var cfg = {};
  try {
    cfg = JSON.parse(root.querySelector('[data-ts-config]').textContent);
  } catch (e) {
    return;
  }

  var STORE_KEY = 'tote-survey-kopstorm:' + (cfg.surveyId || 'default');
  var PAGES_KEY = 'tote-survey-kopstorm:pages';
  var EXIT_KEY = 'tote-survey-kopstorm:exit';
  var DAY = 86400000;

  var pillWrap = root.querySelector('[data-ts-pill-wrap]');
  var panel = root.querySelector('[data-ts-panel]');
  var backdrop = root.querySelector('[data-ts-backdrop]');
  var form = root.querySelector('[data-ts-form]');
  var intro = root.querySelector('[data-ts-intro]');
  var progress = root.querySelector('[data-ts-progress]');
  var backBtn = root.querySelector('[data-ts-back]');
  var done = root.querySelector('[data-ts-done]');
  var steps = Array.prototype.slice.call(root.querySelectorAll('[data-ts-step]'));
  var segs = Array.prototype.slice.call(root.querySelectorAll('.tote-survey__seg'));

  var current = 0;
  var answers = {};
  var opened = false;
  var submitted = false;
  var lastFocus = null;

  /* Storage */
  function read(key, session) {
    try {
      var s = session ? sessionStorage : localStorage;
      return JSON.parse(s.getItem(key) || 'null');
    } catch (e) {
      return null;
    }
  }
  function write(key, value, session) {
    try {
      var s = session ? sessionStorage : localStorage;
      s.setItem(key, JSON.stringify(value));
    } catch (e) {}
  }

  if (/[?&]tote-survey=(reset|on)/.test(location.search)) {
    try {
      localStorage.removeItem(STORE_KEY);
      sessionStorage.removeItem(PAGES_KEY);
      sessionStorage.removeItem(EXIT_KEY);
    } catch (e) {}
  }

  var pages = (read(PAGES_KEY, true) || 0) + 1;
  write(PAGES_KEY, pages, true);

  function blocked() {
    if (cfg.design) return false;
    var state = read(STORE_KEY) || {};
    if (state.done) return true;
    if (state.dismissed && Date.now() - state.dismissed < (cfg.dismissDays || 7) * DAY) return true;
    return pages < (cfg.minPages || 1);
  }

  /* Review link: ?tote-survey=on forces the survey on for this tab, ?tote-survey=off clears it */
  var FORCE_KEY = 'tote-survey-kopstorm:force';
  var forceParam = (location.search.match(/[?&]tote-survey=(on|off)/) || [])[1];
  if (forceParam === 'on') write(FORCE_KEY, 1, true);
  if (forceParam === 'off') {
    try { sessionStorage.removeItem(FORCE_KEY); } catch (e) {}
  }

  function live() {
    if (cfg.mode === 'preview' || cfg.design) return true;
    if (cfg.mode === 'intelligems' && read(FORCE_KEY, true)) return true;
    return document.documentElement.classList.contains('tote-survey-live');
  }

  /* Tracking helpers */
  function signal(name, detail) {
    try {
      if (typeof window.clarity === 'function') {
        window.clarity('event', name);
        window.clarity('set', 'tote_survey', name.replace('tote_survey_', ''));
      }
    } catch (e) {}
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: name, tote_survey: detail || {} });
    } catch (e) {}
    try {
      document.dispatchEvent(new CustomEvent('tote:survey', { detail: { name: name, data: detail || {} } }));
    } catch (e) {}
  }

  /* Corner stacking. Any small fixed widget in the pill's corner (Alia or
     Klaviyo teaser, cookie bar, sticky add to cart) pushes the pill up so it
     sits above it. A large fixed overlay (a full popup) makes the pill wait. */
  var bigOverlay = false;
  function fixedHost(el) {
    for (var n = el; n && n !== document.body && n !== document.documentElement; n = n.parentElement) {
      var cs = getComputedStyle(n);
      if (cs.position === 'fixed') {
        if (cs.visibility === 'hidden' || parseFloat(cs.opacity) === 0) return null;
        return n;
      }
    }
    return null;
  }
  function syncLift() {
    if (cfg.design || !document.elementsFromPoint) return;
    var vw = window.innerWidth;
    var vh = window.innerHeight;
    var edge = parseFloat(getComputedStyle(root).getPropertyValue('--ts-edge')) || 16;
    var width = (!pillWrap.hidden && pillWrap.offsetWidth) || 260;
    var height = (!pillWrap.hidden && pillWrap.offsetHeight) || 44;
    var right = root.classList.contains('tote-survey--right');
    var xs = [8, width / 2, width - 8].map(function (x) {
      return right ? vw - edge - x : edge + x;
    });
    var lift = 0;
    bigOverlay = false;
    for (var round = 0; round < 4; round++) {
      var bottom = vh - edge - lift;
      var ys = [bottom - 6, bottom - height / 2, bottom - height + 6];
      var top = null;
      for (var i = 0; i < xs.length; i++) {
        for (var j = 0; j < ys.length; j++) {
          var stack = document.elementsFromPoint(xs[i], ys[j]);
          for (var k = 0; k < stack.length; k++) {
            var el = stack[k];
            if (root.contains(el) || el === document.body || el === document.documentElement) continue;
            var host = fixedHost(el);
            if (!host || root.contains(host)) continue;
            var r = host.getBoundingClientRect();
            if (r.height > vh * 0.5) {
              bigOverlay = true;
              continue;
            }
            if (top === null || r.top < top) top = r.top;
          }
        }
      }
      if (top === null) break;
      lift = Math.max(lift, Math.ceil(vh - top - edge + 10));
    }
    root.style.setProperty('--ts-lift', lift + 'px');
  }

  /* Shuffle, last option fixed */
  function shuffle(step) {
    var wrap = step.querySelector('[data-ts-options]');
    if (!wrap) return;
    var items = Array.prototype.slice.call(wrap.children);
    if (items.length < 3) return;
    var last = items.pop();
    for (var i = items.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = items[i];
      items[i] = items[j];
      items[j] = t;
    }
    items.concat(last).forEach(function (el) {
      wrap.appendChild(el);
    });
  }
  steps.forEach(function (step) {
    if (step.hasAttribute('data-shuffle')) shuffle(step);
  });

  /* Pill */
  function showPill() {
    if (opened || submitted || blocked()) return;
    syncLift();
    if (bigOverlay) {
      setTimeout(showPill, 3000);
      return;
    }
    pillWrap.hidden = false;
    syncLift();
    watchCorner();
    signal('tote_survey_pill_shown');
  }

  /* Teasers and banners appear and close later, so the corner is checked again while the pill is up */
  var cornerTimer = null;
  function watchCorner() {
    if (cornerTimer) return;
    cornerTimer = setInterval(function () {
      if (pillWrap.hidden || opened) return;
      syncLift();
    }, 1000);
  }

  function dismiss() {
    var state = read(STORE_KEY) || {};
    state.dismissed = Date.now();
    write(STORE_KEY, state);
    pillWrap.hidden = true;
    signal('tote_survey_dismissed');
  }

  /* Panel */
  function renderStep() {
    steps.forEach(function (step, i) {
      step.hidden = i !== current;
    });
    segs.forEach(function (seg, i) {
      seg.classList.toggle('is-done', i <= current);
    });
    intro.hidden = current > 0;
    backBtn.hidden = current === 0;
    var step = steps[current];
    updateNextLabel(step);
    var focusTarget = step.querySelector('.is-selected, [data-ts-option], textarea, input[type="email"]');
    if (focusTarget && opened) {
      try {
        focusTarget.focus({ preventScroll: true });
      } catch (e) {}
    }
  }

  function open(source) {
    if (opened) return;
    opened = true;
    lastFocus = document.activeElement;
    root.classList.add('is-open');
    pillWrap.hidden = true;
    panel.hidden = false;
    if (window.innerWidth < 750) {
      backdrop.hidden = false;
      panel.setAttribute('aria-modal', 'true');
    }
    renderStep();
    signal('tote_survey_opened', { source: source || 'pill' });
  }

  function close() {
    if (!opened) return;
    opened = false;
    root.classList.remove('is-open');
    panel.hidden = true;
    backdrop.hidden = true;
    panel.setAttribute('aria-modal', 'false');
    if (!submitted && !blocked()) {
      pillWrap.hidden = false;
    }
    if (submitted) {
      pillWrap.hidden = true;
    }
    if (lastFocus && lastFocus.focus) {
      try {
        lastFocus.focus({ preventScroll: true });
      } catch (e) {}
    }
    if (!submitted) signal('tote_survey_closed', { step: current + 1 });
  }

  function next() {
    if (current < steps.length - 1) {
      current++;
      renderStep();
      panel.scrollTop = 0;
    }
  }

  function back() {
    if (current > 0) {
      current--;
      renderStep();
    }
  }

  function updateNextLabel(step) {
    var btn = step.querySelector('[data-ts-next]');
    var area = step.querySelector('textarea');
    if (!btn || !area) return;
    var empty = !area.value.trim();
    if (step.hasAttribute('data-required')) {
      btn.disabled = empty;
      btn.textContent = btn.dataset.labelNext;
      return;
    }
    btn.textContent = empty && btn.dataset.labelSkip ? btn.dataset.labelSkip : btn.dataset.labelNext;
  }

  /* Answers */
  root.addEventListener('click', function (e) {
    var option = e.target.closest('[data-ts-option]');
    if (option) {
      var step = option.closest('[data-ts-step]');
      step.querySelectorAll('[data-ts-option]').forEach(function (el) {
        el.classList.toggle('is-selected', el === option);
        el.setAttribute('aria-pressed', el === option ? 'true' : 'false');
      });
      answers[step.dataset.key] = {
        value: option.dataset.value,
        index: parseInt(option.dataset.index, 10)
      };
      setTimeout(next, 260);
      return;
    }
    if (e.target.closest('[data-ts-next]')) {
      var s = e.target.closest('[data-ts-step]');
      var area = s.querySelector('textarea');
      if (area) answers[s.dataset.key] = { value: area.value.trim() };
      next();
      return;
    }
    if (e.target.closest('[data-ts-open]')) return open('pill');
    if (e.target.closest('[data-ts-dismiss]')) return dismiss();
    if (e.target.closest('[data-ts-close]') || e.target === backdrop) return close();
    if (e.target.closest('[data-ts-back]')) return back();
    if (e.target.closest('[data-ts-copy]')) return copyCode(e.target.closest('[data-ts-copy]'));
  });

  root.addEventListener('input', function (e) {
    if (e.target.matches('textarea')) updateNextLabel(e.target.closest('[data-ts-step]'));
    if (e.target.matches('input[type="email"]')) {
      e.target.classList.remove('is-invalid');
      root.querySelector('[data-ts-error]').hidden = true;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && opened) close();
  });

  /* Submit */
  function validEmail(v) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v);
  }

  function withTimeout(promise, ms) {
    return Promise.race([
      promise,
      new Promise(function (resolve) {
        setTimeout(resolve, ms);
      })
    ]).catch(function () {});
  }

  function flatAnswers() {
    var out = {};
    Object.keys(answers).forEach(function (key) {
      var a = answers[key];
      if (!a || !a.value) return;
      out[key] = a.value;
      if (a.index) out[key + '_option'] = a.index;
    });
    return out;
  }

  function toCart(flat) {
    var attrs = {};
    Object.keys(answers).forEach(function (key) {
      var a = answers[key];
      if (!a || !a.value) return;
      attrs['_survey_' + key] = (a.index ? a.index + ' ' : '') + String(a.value).slice(0, 500);
    });
    attrs._survey_id = cfg.surveyId || '';
    return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    });
  }

  function toKlaviyo(email, flat, payload) {
    var k = window.klaviyo;
    var props = Object.assign({ survey_id: cfg.surveyId, page: payload.page, locale: cfg.locale, country: cfg.country }, flat);
    if (k && typeof k.identify === 'function' && typeof k.track === 'function') {
      var chain = email ? Promise.resolve(k.identify({ email: email })) : Promise.resolve();
      return chain.then(function () {
        return k.track(cfg.klaviyoEvent || 'TOTE Survey Completed', props);
      });
    }
    if (Array.isArray(window._learnq)) {
      if (email) window._learnq.push(['identify', { $email: email }]);
      window._learnq.push(['track', cfg.klaviyoEvent || 'TOTE Survey Completed', props]);
    }
    return Promise.resolve();
  }

  function toNewsletter(email) {
    var data = new FormData();
    data.append('form_type', 'customer');
    data.append('utf8', '\u2713');
    data.append('contact[email]', email);
    data.append('contact[tags]', 'newsletter,tote-survey');
    return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'contact', {
      method: 'POST',
      credentials: 'same-origin',
      body: data
    });
  }

  function toWebhook(payload) {
    return fetch(cfg.webhook, {
      method: 'POST',
      mode: 'no-cors',
      headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
      body: JSON.stringify(payload)
    });
  }

  /* Gift reward. The gift only goes into a cart that holds another product,
     because the code makes it free with an order. Completing the survey
     stores a claim; the gift is added with the first other product, taken
     out again when it would be alone, and left alone once the visitor
     removes it themselves. Lines carry the hidden property _survey_gift. */
  var GIFT_KEY = 'tote-survey-kopstorm:gift';
  var GIFT_DAYS = 30;
  var nativeFetch = window.fetch.bind(window);
  var cartBase = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
  var jsonHeaders = { 'Content-Type': 'application/json', Accept: 'application/json' };
  var syncing = null;
  var syncAgain = false;

  function giftClaim() {
    var c = read(GIFT_KEY);
    if (!c || !c.variant || c.done) return null;
    if (Date.now() - (c.at || 0) > GIFT_DAYS * DAY) return null;
    return c;
  }

  function isGiftLine(it, variant) {
    return it.variant_id === variant && it.properties && it.properties._survey_gift;
  }

  function claimGift() {
    if (!cfg.giftVariant) return Promise.resolve();
    write(GIFT_KEY, { variant: cfg.giftVariant, at: Date.now(), added: false, done: false });
    return syncGift();
  }

  function syncGift() {
    if (syncing) {
      syncAgain = true;
      return syncing;
    }
    var claim = giftClaim();
    if (!claim) return Promise.resolve(false);
    syncing = nativeFetch(cartBase + 'cart.js', { credentials: 'same-origin', headers: jsonHeaders })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items || [];
        var gift = null;
        var others = 0;
        items.forEach(function (it) {
          if (isGiftLine(it, claim.variant)) gift = it;
          else others += it.quantity;
        });

        if (others > 0 && !gift) {
          if (claim.added) {
            /* The visitor removed the gift themselves, so it stays out */
            claim.done = true;
            write(GIFT_KEY, claim);
            return false;
          }
          return nativeFetch(cartBase + 'cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: jsonHeaders,
            body: JSON.stringify({ items: [{ id: claim.variant, quantity: 1, properties: { _survey_gift: cfg.surveyId || 'yes' } }] })
          })
            .then(function (r) { return r.json(); })
            .then(function (res) {
              if (res && res.status) {
                console.warn('[tote-survey] gift not added', res);
                return false;
              }
              claim.added = true;
              write(GIFT_KEY, claim);
              return applyCode().then(function () { return true; }, function () { return true; });
            });
        }

        if (others === 0 && gift) {
          /* Alone in the cart the gift would show at full price, so it waits for the next product */
          return nativeFetch(cartBase + 'cart/change.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: jsonHeaders,
            body: JSON.stringify({ id: gift.key, quantity: 0 })
          }).then(function () {
            claim.added = false;
            write(GIFT_KEY, claim);
            return true;
          });
        }
        return false;
      })
      .then(function (changed) {
        if (changed) return refreshCart().then(function () { return changed; });
        return changed;
      })
      .catch(function () { return false; })
      .then(function (changed) {
        syncing = null;
        if (syncAgain) {
          syncAgain = false;
          return syncGift();
        }
        return changed;
      });
    return syncing;
  }

  /* Watch cart changes made by the theme, apps and upsells */
  if (!window.__toteSurveyFetchWrapped) {
    window.__toteSurveyFetchWrapped = true;
    var cartWrite = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var promise = nativeFetch(input, init);
      if (cartWrite.test(url) && giftClaim()) {
        promise.then(function () {
          setTimeout(function () { document.dispatchEvent(new CustomEvent('tote:survey-cart')); }, 250);
        }, function () {});
      }
      return promise;
    };
  }
  document.addEventListener('tote:survey-cart', function () { syncGift(); });

  /* Re-render the theme cart drawer and bubble, so the gift change shows straight away */
  function refreshCart() {
    var drawer = document.querySelector('cart-drawer');
    var events = typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS : window.PUB_SUB_EVENTS;
    if (!drawer || typeof drawer.renderContents !== 'function' || typeof drawer.getSectionsToRender !== 'function') {
      return Promise.resolve();
    }
    var ids = drawer.getSectionsToRender().map(function (s) { return s.section || s.id; });
    return nativeFetch(cartBase + '?sections=' + ids.join(','), { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        if (typeof publish === 'function' && events) {
          publish(events.cartUpdate, { source: 'tote-survey-kopstorm' });
        }
        drawer.classList.remove('is-empty');
        drawer.renderContents({ sections: sections });
      })
      .catch(function () {});
  }

  function applyCode() {
    if (!cfg.code || !cfg.autoApply) return Promise.resolve();
    var base = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
    return nativeFetch(base + 'discount/' + encodeURIComponent(cfg.code) + '?redirect=' + encodeURIComponent(base + 'cart.js'), {
      credentials: 'same-origin'
    });
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (submitted) return;

    var emailInput = form.querySelector('input[type="email"]');
    var email = emailInput ? emailInput.value.trim() : '';
    var needsEmail = cfg.emailRequired || email.length > 0;
    if (needsEmail && !validEmail(email)) {
      emailInput.classList.add('is-invalid');
      root.querySelector('[data-ts-error]').hidden = false;
      emailInput.focus();
      return;
    }

    var btn = form.querySelector('[data-ts-submit]');
    btn.classList.add('is-loading');

    var newsletter = form.querySelector('input[name="newsletter"]');
    var flat = flatAnswers();
    var payload = {
      survey_id: cfg.surveyId,
      submitted_at: new Date().toISOString(),
      email: email,
      newsletter: !!(newsletter && newsletter.checked),
      answers: flat,
      page: location.pathname,
      page_type: cfg.pageType,
      referrer: document.referrer || '',
      locale: cfg.locale,
      country: cfg.country,
      currency: cfg.currency,
      customer_id: cfg.customer,
      device: window.innerWidth < 750 ? 'mobile' : 'desktop'
    };

    var jobs = [];
    /* Cart writes run one after another so the attributes, gift line and code never race. */
    jobs.push(withTimeout(safe(function () {
      var first = cfg.saveToCart ? safe(function () { return toCart(flat); }) : Promise.resolve();
      var noop = function () {};
      return first.catch(noop).then(applyCode).catch(noop).then(function () { return safe(claimGift); });
    }), 8000));
    if (cfg.klaviyo) jobs.push(withTimeout(safe(function () { return toKlaviyo(email, flat, payload); }), 4000));
    if (payload.newsletter && email) jobs.push(withTimeout(safe(function () { return toNewsletter(email); }), 4000));
    if (cfg.webhook) jobs.push(withTimeout(safe(function () { return toWebhook(payload); }), 4000));

    Promise.all(jobs).then(function () {
      submitted = true;
      if (!cfg.design) write(STORE_KEY, { done: Date.now() });
      form.hidden = true;
      segs.forEach(function (seg) {
        seg.classList.add('is-done');
      });
      intro.hidden = true;
      backBtn.hidden = true;
      done.hidden = false;
      btn.classList.remove('is-loading');
      signal('tote_survey_completed', flat);
      try {
        done.focus({ preventScroll: true });
      } catch (err) {}
    });
  });

  function copyCode(btn) {
    var label = btn.querySelector('[data-ts-copy-label]');
    var original = label.textContent;
    var finish = function () {
      label.textContent = btn.dataset.labelDone || original;
      setTimeout(function () {
        label.textContent = original;
      }, 2000);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(cfg.code).then(finish, finish);
    } else {
      var t = document.createElement('textarea');
      t.value = cfg.code;
      document.body.appendChild(t);
      t.select();
      try {
        document.execCommand('copy');
      } catch (e) {}
      t.remove();
      finish();
    }
  }

  /* Exit intent, desktop only */
  function bindExitIntent() {
    if (!cfg.exitIntent || window.matchMedia('(hover: none)').matches) return;
    document.addEventListener('mouseout', function (e) {
      if (e.relatedTarget || e.clientY > 8) return;
      if (opened || submitted || pillWrap.hidden || read(EXIT_KEY, true)) return;
      if (document.body.classList.contains('overflow-hidden')) return;
      write(EXIT_KEY, 1, true);
      open('exit_intent');
    });
  }

  /* Start */
  var started = false;
  function start() {
    if (started || !live() || blocked()) return;
    started = true;
    setTimeout(showPill, cfg.design ? 0 : (cfg.delay || 0) * 1000);
    bindExitIntent();
    var scrollTick = null;
    window.addEventListener('scroll', function () {
      if (scrollTick || pillWrap.hidden) return;
      scrollTick = setTimeout(function () {
        scrollTick = null;
        syncLift();
      }, 150);
    }, { passive: true });
    window.addEventListener('resize', syncLift);
  }

  start();

  /* A claimed gift is checked on every page load, also for visitors outside the test */
  if (giftClaim()) syncGift();

  if (cfg.mode === 'intelligems' && !started) {
    var mo = new MutationObserver(function () {
      if (live()) {
        mo.disconnect();
        start();
      }
    });
    mo.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
  }

  /* Theme editor */
  if (cfg.design) {
    document.addEventListener('shopify:section:select', function (e) {
      if (e.detail && e.detail.sectionId === root.dataset.sectionId) open('editor');
    });
    document.addEventListener('shopify:section:deselect', function (e) {
      if (e.detail && e.detail.sectionId === root.dataset.sectionId) close();
    });
    document.addEventListener('shopify:block:select', function (e) {
      var idx = steps.findIndex(function (s) {
        return s.contains(e.target) || s === e.target;
      });
      if (idx > -1) {
        open('editor');
        current = idx;
        renderStep();
      }
    });
  }
  }

  function safe(fn) {
    try {
      return Promise.resolve(fn());
    } catch (e) {
      return Promise.resolve();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
